import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BasicModal from "src/features/student-attendance/components/modal";
import BusesDeleteConfirm from "./buses-delete-confirm";

const BusDeleteButton = ({ bus }) => {
  const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);

  const handleDeleteConfirmClose = () => {
    setOpenDeleteConfirmModal(false);
  };

  return (
    <>
      <span>
        <button
          className="btn btn-danger w-100 btn-sm-custom"
          onClick={() => setOpenDeleteConfirmModal(true)}
        >
          <FontAwesomeIcon icon="trash" />
        </button>
      </span>

      {/* Delete Confirmation Modal - Individual modal for this row */}
      <BasicModal
        title={`バス削除の確認 - ${bus?.name || "バス"}`}
        isOpen={openDeleteConfirmModal}
        onCancel={handleDeleteConfirmClose}
        width="50%"
      >
        <BusesDeleteConfirm
          key={`delete-confirm-${bus?.id}`}
          busId={bus?.id}
          onClose={handleDeleteConfirmClose}
        />
      </BasicModal>
    </>
  );
};

export default BusDeleteButton;
